export const buildInitialState = () => ({
  leads: {
    data: [],
    loading: false,
    lastUpdate: null,
    tags: [],
  },
  filterLeads: {},
  ligacoes: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  filterLigacoes: {},
  // Funil selecionado no pipeline de leads (id). null => usa o ativo (fallback).
  selectedFunilId: null,
  reguaRelacionamento: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  atividadesRegua: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  reguaCliente: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  funil: {
    data: [],
    loading: false,
    lastUpdate: null,
    customizeLoading: false,
  },
  historicoAtividade: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  atividadesSugeridas: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  empresas: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  gruposFamiliares: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  // Slot próprio da tela de listagem: shape diferente do slot acima (traz
  // membros e contagens de escopo) e ciclo de cache independente, para que a
  // listagem não invalide o cache do autocomplete dos modais e vice-versa.
  gruposFamiliaresListagem: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  funilSteps: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  funilStepsTasks: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  // Funil de oportunidades (realtime config: funis + etapas + atividades).
  oportunidadeFunil: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  // Etapas de oportunidade (config flat, usado pelo builder).
  oportunidadeFunilEtapas: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  // Atividades-template de oportunidade (config flat, usado pelo builder).
  oportunidadeFunilAtividades: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  // Payload completo do kanban (funis -> etapas -> oportunidades + fechados).
  oportunidadeFunilCompleto: {
    data: { funis: [] },
    loading: false,
    lastUpdate: null,
  },
  // Motivos de perda configuráveis por escritório.
  oportunidadeMotivosPerda: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  origens: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  clients: {
    data: [],
    summaryData: {},
    loading: false,
    lastUpdate: null,
    tags: [],
  },
  clientsTasks: {
    data: [],
    summaryData: {},
    loading: false,
    loadingNoSave: false,
    lastUpdate: null,
    tags: [],
  },
  filtersRelationship: {
    data: {},
  },
  leadTimeline: {
    data: [],
    summaryData: {},
    loading: false,
    lastUpdate: null,
    tags: [],
  },
  kYC: {
    data: [],
    summaryData: {},
    loading: false,
    lastUpdate: null,
    tags: [],
  },
  kYCList: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  historicoLead: {
    data: [],
    summaryData: {},
    loading: false,
    lastUpdate: null,
    tags: [],
  },
  timelineClient: {
    data: [],
    loading: false,
    lastUpdate: null,
    tags: [],
  },
  crmIntegrationEmail: {
    data: [],
    loading: false,
    lastUpdate: null,
    providers: [],
  },
  overviewIndicators: {
    data: {},
    loading: false,
    lastUpdate: null,
  },
  funilStepsConfig: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  monthlyRoutine: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  relationshipKanban: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  opportunitiesKanban: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  calendar: {
    data: [],
    loading: false,
    loadingMonth: false,
    loadedMonths: {},
    lastUpdate: null,
    googleAgenda: {
      autenticado: false,
      erro: null,
    },
    microsoftAgenda: {
      autenticado: false,
      erro: null,
    },
  },
  filterCalendar: {},
  observacoes: {
    byClient: {},
    loadingByClient: {},
  },
  clienteLeadStatus: {
    byClienteApp: {},
    loadingByClienteApp: {},
  },
  customFields: {
    data: [],
    loading: false,
    lastUpdate: null,
    loaded: false,
  },
  // Schema da Ficha do Cliente (IA): grupos/campos de
  // GET /clients/ficha/schema. Não toca banco no backend — cacheado 1x por
  // sessão (D8), nunca em localStorage (R7 — um F5 já renova após deploy).
  fichaSchema: {
    data: null,
    loading: false,
    lastUpdate: null,
    loaded: false,
  },
  summary: {
    layouts: { lead: [], cliente: [] },
    layoutsLoaded: { lead: false, cliente: false },
    catalogs: { lead: [], cliente: [] },
    catalogsLoaded: { lead: false, cliente: false },
    dataByClienteId: {},
  },
  overview: {
    layouts: { escritorio: [], profissional: [] },
    layoutsLoaded: { escritorio: false, profissional: false },
    isDefault: { escritorio: false, profissional: false },
    // Gestor bloqueou a personalizacao do painel pelos assessores.
    customizationBlocked: { escritorio: false, profissional: false },
    catalog: [],
    catalogLoaded: false,
  },
  transcriptProjects: {
    data: [],
    loading: false,
    lastUpdate: null,
  },
  // Scores por critério de uma transcrição (aba Avaliação). Indexado por id da
  // transcrição: byTranscript[id] = [TranscriptionScore]; loadingByTranscript[id].
  transcriptScores: {
    byTranscript: {},
    loadingByTranscript: {},
  },
  crmEmails: {
    cliente: {
      data: [],
      contadores: { todos: 0, recebido: 0, enviado: 0, lixeira: 0 },
      loading: false,
      lastUpdate: null,
      pagination: { page: 1, per_page: 20, total: 0, pages: 0 },
      folder: 'todos',
      idClienteApp: null,
    },
    global: {
      data: [],
      contadores: { todos: 0, recebido: 0, enviado: 0, lixeira: 0 },
      loading: false,
      lastUpdate: null,
      pagination: { page: 1, per_page: 20, total: 0, pages: 0 },
      folder: 'todos',
    },
    firstAutoSyncDone: false,
  },
})

export default buildInitialState()
